const TOKEN_KEY = 'qp_auth_token';
let memoryToken = null;
export class ApiError extends Error {
    constructor(status, code) {
        super(code);
        this.status = status;
        this.code = code;
        this.name = 'ApiError';
    }
}
export function getToken() {
    if (memoryToken)
        return memoryToken;
    try {
        return localStorage.getItem(TOKEN_KEY);
    }
    catch {
        return null;
    }
}
export function setToken(token) {
    memoryToken = token;
    try {
        localStorage.setItem(TOKEN_KEY, token);
    }
    catch {
        /* ignore quota errors */
    }
}
export function clearToken() {
    memoryToken = null;
    try {
        localStorage.removeItem(TOKEN_KEY);
    }
    catch {
        /* ignore */
    }
}
const API_BASE = process.env.API_BASE_URL || '/api';
let onSaveSuccess = null;
export function setOnSaveSuccess(cb) {
    onSaveSuccess = cb;
}
export async function apiFetch(path, init = {}) {
    const headers = new Headers(init.headers);
    if (!headers.has('Content-Type') && init.body) {
        headers.set('Content-Type', 'application/json');
    }
    const token = getToken();
    if (token) {
        headers.set('Authorization', `Bearer ${token}`);
    }
    const res = await fetch(`${API_BASE}${path}`, {
        ...init,
        headers,
        credentials: 'include',
    });
    if (!res.ok) {
        const body = (await res.json().catch(() => ({})));
        throw new ApiError(res.status, body.error ?? 'request_failed');
    }
    const method = (init.method ?? 'GET').toUpperCase();
    if (method !== 'GET' && onSaveSuccess) {
        onSaveSuccess();
    }
    if (res.status === 204)
        return undefined;
    const text = await res.text();
    if (!text)
        return undefined;
    return JSON.parse(text);
}
